import angular from 'angular';
import uiRouter from 'angular-ui-router';
import linkTypeChoiceComponent from './linkTypeChoice.component';

let linkTypeChoiceModule = angular.module('linkTypeChoice', [
  uiRouter
])

.component('linkTypeChoice', linkTypeChoiceComponent)

.name;

export default linkTypeChoiceModule;
